export default "__VITE_ASSET__CnaYOm3s__"